import ReactGA from 'react-ga4';

const GA_ID =
  window.location.hostname === import.meta.env.VITE_DOMAIN_TRIPUK
    ? import.meta.env.VITE_GOOGLE_ANALYTICS
    : window.location.hostname === import.meta.env.VITE_DOMAIN_US
      ? import.meta.env.VITE_GOOGLE_ANALYTICS_US
      : window.location.hostname === import.meta.env.VITE_DOMAIN_US_CHUBB
        ? import.meta.env.VITE_GOOGLE_ANALYTICS_CHUBB
        : window.location.hostname === import.meta.env.VITE_DOMAIN_US_METLIFE
          ? import.meta.env.VITE_GOOGLE_ANALYTICS_METLIFE
          : window.location.hostname === import.meta.env.VITE_DOMAIN_USTI
            ? import.meta.env.VITE_GOOGLE_ANALYTICS_USTI
            : window.location.hostname === import.meta.env.VITE_DOMAIN_WWIIS
              ? import.meta.env.VITE_GOOGLE_ANALYTICS_WWIIS
              : import.meta.env.VITE_GOOGLE_ANALYTICS_GENERIC;

export const initializeGoogleAnalytics = () => {
  // Initialize google analytics page view tracking
  if (GA_ID) {
    ReactGA.initialize(GA_ID);
  }
};
